import Vue from 'vue'
import {
  Button,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Form,
  TabPane,
  Tabs,
  Panel,
  Collapse,
  FormItem,
  Input,
  Message,
  Modal,
  Card,
  Row,
  Col,
  BackTop,
  Page,
  Slider,
  Select,
  Option,
  CheckboxGroup,
  Checkbox,
  Cascader
} from 'view-design'
// Vue.component('Button', Button)
// Vue.component('DropdownMenu', DropdownMenu)
// Vue.component('DropdownItem', DropdownItem)
// Vue.component('Dropdown', Dropdown)
// Vue.component('Form', Form)
// Vue.component('FormItem', FormItem)
// Vue.component('Input', Input)
// Vue.component('Message', Message)
// Vue.component('Menu', Menu)
// Vue.component('MenuItem', MenuItem)
// Vue.component('Submenu', Submenu)
// Vue.component('MenuGroup', MenuGroup)

Vue.prototype.$Message = Message
// iview基础模块
const components = {
  Button,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Form,
  FormItem,
  Input,
  Modal,
  TabPane,
  Panel,
  Collapse,
  Tabs,
  Card,
  Row,
  Col,
  BackTop,
  Page,
  Slider,
  Select,
  Option,
  CheckboxGroup,
  Checkbox,
  Cascader
}

const iviewModule = {
  ...components,
  // 不能和html标签重复的组件，添加别名(除了Switch、Circle在使用中必须是iSwitch、iCircle,其他都可以不加"i")
  iButton: Button,
  iForm: Form,
  iInput: Input
}
// 循环注册全局组件
Object.keys(iviewModule).forEach((key) => {
  Vue.component(key, iviewModule[key])
})
